import React from 'react';
import './App.css';
import { PlatformMessagesWrapper } from './services/platformMessagesWrapper';
import { init } from './core/init';
import Game from './containers/common/game';

function App() {
  init();

  return (
    <PlatformMessagesWrapper>
      <Game />
    </PlatformMessagesWrapper>
  );
}

export default App;
